import type { ShipmentSupplierDisplay } from './types';
import { initials } from './utils';

type Props = {
    display: ShipmentSupplierDisplay | null | undefined;
    fallbackLabel?: string;
};

export default function SupplierBrandCell({ display, fallbackLabel }: Props) {
    const label = display?.label && display.label !== '—' ? display.label : (fallbackLabel?.trim() || '—');
    const color = display?.thumbnail_color ?? '#9CA3AF';

    return (
        <div className="flex min-w-[120px] items-center gap-2">
            {display?.logo_url ? (
                <img
                    src={display.logo_url}
                    alt=""
                    className="h-8 w-8 shrink-0 rounded-md border border-gray-200 bg-white object-contain p-0.5"
                />
            ) : (
                <span
                    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-[10px] font-bold text-white"
                    style={{ backgroundColor: color }}
                >
                    {initials(label)}
                </span>
            )}
            <span className="line-clamp-2 text-sm font-medium text-gray-900">{label}</span>
        </div>
    );
}
